import { Link } from "react-router-dom";

export const SiteHeader = () => (
  <header
    data-testid="site-header"
    className="fixed left-0 right-0 top-0 z-40 bg-paper/80 backdrop-blur-md"
  >
    <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-5">
      <Link
        to="/"
        data-testid="header-wordmark"
        className="font-garamond text-xl tracking-wide text-ink"
      >
        syndeō
      </Link>
      <nav className="flex items-center gap-8 sm:gap-12">
        <Link
          to="/apply"
          data-testid="nav-members"
          className="font-garamond text-lg text-ink/80 transition-colors duration-300 hover:text-ink"
        >
          Members
        </Link>
        <Link
          to="/professionals"
          data-testid="nav-recommend"
          className="font-garamond text-lg text-ink/80 transition-colors duration-300 hover:text-ink"
        >
          Professionals
        </Link>
      </nav>
    </div>
  </header>
);
